import { Toolbar } from "primereact/toolbar";
import "./changePassword.component.css";
import { Dialog } from "primereact/dialog";
import ShareComponent from "../Share/share.component";
import { SpecialZoomLevel, ViewMode, Viewer } from "@react-pdf-viewer/core";
import LoadingSpinner from "../loading-spinner/loading-spinner";
import { Worker } from "@react-pdf-viewer/core";
import { useEffect, useState } from "react";
import {
  Enum_ValidationString,
  checkValidationRequiredString,
  goTo,
} from "../../utilities/common.utilities";
import { Password } from "primereact/password";
import { MAXLENGTH_PASSWORD } from "../../static/constants";
import { Button } from "primereact/button";
import { useSearchParams } from "react-router-dom";
import { isValidLinkResetPsw, resetPassword } from "../../service/forgotPassword.service";
import { checkCodeResponseModel } from "../../static/forgotPassword.model";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import {installPWA, onClickInstallButton, pwaInstalled} from "../../utilityPWA";
import PopupInstallComponent from "../PopupInstall/popupInstall.component";
import FooterPreLoginComponent from "../Footer/footer-pre-login.component";
import { useConnectivity } from "../../context/connectivityContext";

type InputInfoStatus = {
  value: string;
  valid: boolean;
  showError: boolean;
};

type ErrorCheckCode = {
  status: number;
  titleMessage: string;
  message: string;
}

const defaultInfoStatus: InputInfoStatus = {
  value: "",
  valid: false,
  showError: false,
};

export default function ChangePasswordComponent() {

  const [searchParams, setSearchParams] = useSearchParams();

  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [showSharingComponent, setShowSharingComponent] =
    useState<boolean>(false);
  const [showTermsOfUse, setShowTermsOfUse] = useState<boolean>(false);
  const [password, setPassword] = useState<InputInfoStatus>(defaultInfoStatus);
  const [matchPassword, setMatchPassword] =
    useState<InputInfoStatus>(defaultInfoStatus);

  const [loadingCheck, setLoadingCheck] = useState<boolean>(true);
  const [checkCode, setCheckCode] = useState<string>('');
  const [errorCheckCode, setErrorCheckCode] = useState<ErrorCheckCode>({status: 200, titleMessage: '', message: ''});

  // Variabile per sapere se si è ricevuti il check code dal server
  const [isGetCheckCode, setIsGetCheckCode] = useState<boolean>(false);


  const [showPopupInstall, setShowPopupInstall] = useState<boolean>(false);
  const { isOnline } = useConnectivity();


  useEffect(() => {

    if(!isGetCheckCode) {

    let checkCodeFromParams: string = searchParams.get('checkCode') || '';
    
    // if(checkCodeFromParams) {
      setCheckCode(checkCodeFromParams);
      setLoadingCheck(true);

      isValidLinkResetPsw(checkCodeFromParams)
       .then((response) => {
         setLoadingCheck(false);
         setIsGetCheckCode(true);
       })
       .catch((error)=> {
          let statusError: number = error?.response?.status || 404;
          let timeoutMinutes: number = (error.response?.data as checkCodeResponseModel)?.timeoutMinutes;
          let infoError: ErrorCheckCode = manageError(statusError, timeoutMinutes);

          setErrorCheckCode(infoError)
          setLoadingCheck(false);
          setIsGetCheckCode(true);
        })
    }

  }, [isOnline]);  // Indico di reindirizzare il componente quando la variabile isOnline cambia valore


  function manageError(errorCode: number, timeoutMinutes: number): ErrorCheckCode {

    let title: string = 'Si è verificato un errore';
    let message: string = 'Riprovare più tardi.';

    switch(errorCode) {
      case 400:
        title = 'Richiesta non valida';
        message = 'La richiesta di cambio password non è valida. L\'indirizzo potrebbe essere incompleto. '+
          '<br/>Si prega di riprovare o di inviare una nuova richiesta.'
        break;

      case 404:
        
        title = 'Richiesta non trovata';
        message = 'La richiesta di cambio password non è stata trovata. L\'indirizzo potrebbe essere incompleto o errato. '+
          '<br/>Si prega di riprovare o di inviare una nuova richiesta.'
        break;

      case 408:
        
        title = 'Richiesta scaduta';
        message = 'La richiesta di cambio password è scaduta. Ogni richiesta ha una validità massima di ' +
          timeoutMinutes + ' minuti.<br/>Si prega di inviarne una nuova.';
        break;

      case 410:
        title = 'Richiesta completata';
        message = 'L\'operazione di cambio password legata a questa richiesta è stata già eseguita.';
        break;

      case 426:
        title = 'Richiesta disattivata';
        message = 'E\' presente una richiesta di cambio password più recente. ' +
          'Si prega di utilizzare il collegamento presente nell\' ultima email ricevuta o di inviare una nuova richiesta '+
          ' ed attendere la nuova email.';
        break;
    }

    let infoError: ErrorCheckCode = { status: errorCode, titleMessage: title, message: message };
    return infoError;
  }

  function onChangePassword(passwordValue: string) {
    // per la password rimuovo tutti gli spazi
    passwordValue = passwordValue ? passwordValue.replaceAll(" ", "") : "";
    let checkMatchPsw: boolean = checkValidationRequiredString(
      matchPassword.value,
      Enum_ValidationString.Password,
      passwordValue
    );
    let passwordInfo: InputInfoStatus = {
      value: passwordValue,
      valid: checkValidationRequiredString(
        passwordValue,
        Enum_ValidationString.Password
      ),
      showError: password.showError,
    };
    setPassword(passwordInfo);
    setMatchPassword({
      value: matchPassword.value,
      valid: checkMatchPsw,
      showError: matchPassword.showError,
    });
  }
  function onBlurPassword() {
    let blurPasswordInfo: InputInfoStatus = {
      value: password.value,
      valid: checkValidationRequiredString(
        password.value,
        Enum_ValidationString.Password
      ),
      showError: password.showError,
    };
    blurPasswordInfo.showError = true;
    setPassword(blurPasswordInfo);
  }

  function onChangeMatchPassword(valuePassword: string) {
    // per la password rimuovo tutti gli spazi
    valuePassword = valuePassword ? valuePassword.replaceAll(" ", "") : "";

    let matchPasswordInfo: InputInfoStatus = {
      value: valuePassword,
      valid: checkValidationRequiredString(
        valuePassword,
        Enum_ValidationString.Password,
        password.value
      ),
      showError: matchPassword.showError,
    };
    setMatchPassword(matchPasswordInfo);
  }
  function onBlurMatchPassword() {
    let blurMatchPassword: InputInfoStatus = {
      value: matchPassword.value,
      valid: checkValidationRequiredString(
        matchPassword.value,
        Enum_ValidationString.Password,
        password.value
      ),
      showError: matchPassword.showError,
    };
    blurMatchPassword.showError = true;
    setMatchPassword(blurMatchPassword);
  }
  function getErrorMatchPassword(): string {
    let messageErrorPassword: string = "";

    if (matchPassword !== password) {
      messageErrorPassword = " La password non corrisponde ";
    } else {
      messageErrorPassword = " Campo obbligatorio ";
    }
    return messageErrorPassword;
  }

  function getContentError() {
    return (
      <div className="flex align-items-center">
        <i className="pi pi-exclamation-triangle" style={{color: '#ff5757', fontSize: '1.5rem'}}></i>
        <div className="ml-4"> { errorCheckCode.message } </div>
      </div>
    )
  }

  function showConfirmChange(event: any) {
    event.preventDefault();
    if(password.value && password.valid) {
      confirmDialog({
        message: 'Reimpostare la password?',
        header: "Conferma operazione",
        acceptLabel: "Si",
        modal: true,
        accept: () => {
          changePassword();
        }
      })
    }
  }

  async function changePassword() {

    if(password.value && password.valid) {

      await resetPassword(password.value, checkCode)
        .then(response => {

          if(response?.status === 200) {
            setShowDialog(true);
          }
          else if(response?.status) {

            let statusError: number = response.status;
            let timeoutMinutes: number = (response?.data as checkCodeResponseModel)?.timeoutMinutes;
            let infoError: ErrorCheckCode = manageError(statusError, timeoutMinutes);

            setErrorCheckCode(infoError)
          }

        })

    }
  }

  
  const footerContent = (
    <div>
      <Button
        label="Ok"
        icon="pi pi-check"
        onClick={() => {
          setShowDialog(false);
          window.location.href = process.env.REACT_APP_BASE_URL + '/login';
        }}
        autoFocus
      />
    </div>
  );

  return (
    <>
      <div className="header-change-password">
      <PopupInstallComponent openManually={true} showBehaviorManually={showPopupInstall} 
        onClosePopup={() => {
          if(showPopupInstall) {
              setShowPopupInstall(false)
          }}
        }
      />
        {/* <div className="grid title-change-password  mt-1 flex align-items-center justify-content-center">
          <div className="col-2">
            <div className="flex align-items-center justify-content-center">
                  <div className="flex flex-column" style={{cursor:'pointer'}} onClick={() => goTo('/home')}>
                    <div className="flex align-items-center justify-content-center text-white w-3rem h-3rem" >
                      <i className="pi pi-arrow-left inline-flex justify-content-center align-items-center text-white"
                        style={{ fontSize: '2rem' }}>
                      </i>
                    </div>
                    <div className="flex align-items-center justify-content-center font-bold text-white">
                      <label style={{ fontSize: '8px', fontWeight: 'bold' }} htmlFor="backButton">INDIETRO</label>
                    </div>
                  </div>
                </div>
            </div>
          <div className="col-8 flex align-items-center justify-content-center">
            <span className="mb-2 mt-2">Cambia Password</span>
          </div>
        </div> */}
        <div className="grid title-change-password mt-1">

          <div className="col-2 flex align-items-center justify-content-start pl-4">

            <div className="flex flex-column" style={{cursor:'pointer'}} 
                onClick={() => { window.location.href = process.env.REACT_APP_BASE_URL + '/login' }}>
                <div className="flex align-items-center justify-content-center text-white">
                  <i className="pi pi-arrow-left icons-header"></i>         
                </div>
                <div className="flex align-items-center justify-content-center font-bold text-white" 
                  style={{  position: 'relative', top: '-5px' }} >
                    <label style={{ fontSize: '8px', fontWeight: 'bold' }} htmlFor="backLoginButton">INDIETRO</label>
                </div>
            </div>


          </div>

          <div className="col-8 flex align-items-center justify-content-center">

            {
              process.env.REACT_APP_SUFFIX_TITLE_HEADER
              ? 
              <div className="flex flex-column mt-1">
                <div>Cambia Password</div>

                <div className="flex justify-content-end text-sm font-normal">
                  <div className="flex align-items-center justify-content-center title-login">
                      {process.env.REACT_APP_SUFFIX_TITLE_HEADER}
                  </div>
                </div>
              </div>
              :
              <span className="mb-3 mt-2">Cambia Password</span>
            }

          </div>
        </div>
      </div>

      <div className="content-change-password">
        <ConfirmDialog />

        <Dialog
          visible={showDialog}
          modal={true}
          // header={headerElement}
          footer={footerContent}
          style={{ width: "22rem" }}
          closable={false}
          onHide={() => setShowDialog(false)}>
          <p className="m-0">Aggiornamento avvenuto con successo</p>
        </Dialog>

        {
          loadingCheck
          ?
          <></>
          :
          (!isGetCheckCode && !isOnline) 
          ?
          <div className="flex flex-column align-items-center text-lg">

            <div className='mb-3'>
              <img src="./offline_globe.svg" alt="" className="img-offline-globe-empty-result"></img>
            </div>

            <div>Richiesta non disponibile.</div>
            {
              navigator.onLine
              ?
              <></>
              :
              <div>Verifica la connessione internet.</div>
            }
          </div>
          :
          errorCheckCode.status !== 200
          ?
          <>
            <div className="flex flex-column w-full align-items-center justify-content-center px-3">

              <div>
                <i className="pi pi-exclamation-triangle" style={{ fontSize: '5rem' }}></i>
              </div>

              <h2 className="text-center">
                { errorCheckCode.titleMessage }
              </h2>

            

              <div className="my-2">
                <div className="mx-auto px-2" dangerouslySetInnerHTML={{ __html: errorCheckCode.message }}>
                </div>
              </div>

              <div className="flex flex-column w-full justify-content-center align-items-center mt-6" >
                <Button
                    onClick={() => { window.location.href = process.env.REACT_APP_BASE_URL + '/forgot-password' }}
                    label="Reinvia richiesta"
                    className="button-change flex align-items-center justify-content-center"
                ></Button>
              </div>

              <div>
                
              </div>

            </div>
          </>
          :
          <form action="" method="" noValidate>
          <div className="flex flex-column gap-5">
          <div className="w-full flex flex-column align-items-center justify-content-center gap-5 py-5">
            <div className="flex flex-wrap justify-content-center align-items-center gap-5">
              <div className="flex flex-column justify-content-center align-items-center signup-input-style mt-3 ">
                <span className="p-float-label w-full">
                  <Password
                    inputRef={ref => ref?.setAttribute('tabIndex','1')}
                    className="input-psw-width w-full"
                    value={password.value}
                    onChange={(e) => onChangePassword(e.target.value)}
                    feedback={false}
                    onBlur={() => onBlurPassword()}
                    toggleMask
                    maxLength={MAXLENGTH_PASSWORD}
                    invalid={!password.valid && password.showError}
                  />
                  <label
                    htmlFor="Password"
                    className="change-psw-label"
                  >
                    Nuova password*
                  </label>
                </span>
                {password.valid || !password.showError ? (
                  <></>
                ) : (
                  <div className="flex flex-column w-full">
                    <small>
                      {password.value.length === 0 ? (
                        <span className="text-red-600 ">
                          Campo Obbligatorio.
                        </span>
                      ) : (
                        <span className="text-red-600">
                          Deve contenere minimo 8 caratteri, di cui almeno uno
                          in maiuscolo e un numero
                        </span>
                      )}
                    </small>
                  </div>
                )}
              </div>

              <div className="flex flex-column justify-content-center align-items-center signup-input-style mt-3 mb-1 ">
                <span className="p-float-label w-full">
                  <Password
                    inputRef={ref => ref?.setAttribute('tabIndex','2')}
                    className="w-full"
                    value={matchPassword.value}
                    onChange={(e) => onChangeMatchPassword(e.target.value)}
                    feedback={false}
                    onBlur={() => onBlurMatchPassword()}
                    toggleMask
                    maxLength={MAXLENGTH_PASSWORD}
                    invalid={!password.valid && password.showError}
                  />
                  <label
                    htmlFor="ConfermaPassword"
                    className="change-psw-label"
                  >
                    Conferma nuova password*
                  </label>
                </span>
                {matchPassword.valid || !matchPassword.showError ? (
                  ""
                ) : (
                  <div className="flex flex-column w-12">
                    <small className="text-red-600">
                      <span>{getErrorMatchPassword()}</span>
                    </small>
                  </div>
                )}
              </div>

              <div className="flex flex-column w-full justify-content-center align-items-center mt-2" >
                {/* <Button
                    onClick={() => {
                        goTo("/login")
                    }}
                    label="Annulla"
                    // disabled={!isFormValid()}
                    
                    className="button-change mb-4 flex align-items-center justify-content-center"
                ></Button> */}
                <Button
                    type="submit"
                    onClick={(e) => { showConfirmChange(e) }}
                    label="Cambia"
                    disabled={ !matchPassword.valid }
                    className="button-change flex align-items-center justify-content-center"
                ></Button>
              </div>

            </div>
          </div>
        </div>
        </form>
        }
        
      </div>

      <FooterPreLoginComponent />
    </>
  );
}
